__turbopack_context__.v({
  "BibliotecaVirtual": "-SnoKa_BibliotecaVirtual",
  "Pearson": "-SnoKa_Pearson",
  "boxLogos": "-SnoKa_boxLogos",
  "containerLogos": "-SnoKa_containerLogos",
  "containerNomesInstituicoesFederais": "-SnoKa_containerNomesInstituicoesFederais",
  "contentLogos": "-SnoKa_contentLogos",
  "contentNecessidade": "-SnoKa_contentNecessidade",
  "contentPerfomance": "-SnoKa_contentPerfomance",
  "contentSobreBV": "-SnoKa_contentSobreBV",
  "contentSobrePearson": "-SnoKa_contentSobrePearson",
  "dFlex": "-SnoKa_dFlex",
  "editoras": "-SnoKa_editoras",
  "imgContentSobre": "-SnoKa_imgContentSobre",
  "imgNecessidade": "-SnoKa_imgNecessidade",
  "imgPearson": "-SnoKa_imgPearson",
  "imgPerfomance": "-SnoKa_imgPerfomance",
  "itemEditora": "-SnoKa_itemEditora",
  "itemLogo": "-SnoKa_itemLogo",
  "logoIF": "-SnoKa_logoIF",
  "necessidade": "-SnoKa_necessidade",
  "performance": "-SnoKa_performance",
  "quemSomos": "-SnoKa_quemSomos",
  "rowEditoras": "-SnoKa_rowEditoras",
  "swiper": "-SnoKa_swiper",
  "tag": "-SnoKa_tag",
  "title": "-SnoKa_title",
  "uiContainer": "-SnoKa_uiContainer",
});
